export const SpinnerIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M194.5 92C194.5 89.2386 196.739 87 199.5 87C234.018 87 262 114.982 262 149.5C262 184.018 234.018 212 199.5 212C183.143 212 168.244 205.71 157.108 195.426C155.079 193.552 154.953 190.389 156.827 188.36C158.7 186.332 161.864 186.206 163.892 188.079C173.254 196.725 185.755 202 199.5 202C228.495 202 252 178.495 252 149.5C252 120.505 228.495 97 199.5 97C196.739 97 194.5 94.7614 194.5 92Z'
      fill='#38B2AC'
    />
  </svg>
)
